import styled, { css } from 'styled-components';
import { COLORS } from '../../../constants/style/color';
import { rem } from '../../../utils/style';

// ── Tracking Section: outer container with visible border/background ──
export const TrackingSectionContainer = styled.div`
  border: 1px solid ${COLORS.LightGray};
  border-radius: 8px;
  background: ${COLORS.Grey100Transparent};
  padding: ${rem(20)} ${rem(20)};
  margin-top: ${rem(8)};
`;

// ── Final Evaluation header block ──
export const FinalEvaluationHeader = styled.div`
  border-radius: 4px;
  padding: ${rem(4)} 0 ${rem(8)} 0;
`;

// ── Evaluation Section: bordered container matching tracking table style ──
export const EvaluationSectionContainer = styled.div`
  border: 1px solid ${COLORS.LightGray};
  border-radius: 8px;
  background: ${COLORS.White};
  padding: ${rem(20)} ${rem(20)};
  margin-top: ${rem(8)};
`;

interface estimationType {
  array?: number;
}

export const EstimationTrackingAccordingContainer = styled.div`
  background: ${COLORS.Grey400Transparent};
  /* opacity: 0.5; */
  border-bottom: 1px solid ${COLORS.LightGray};
  border-radius: 6px 6px 0px 0px;
  padding: ${rem(13)} ${rem(15)};
  font-weight: 500;
`;

export const EstimationTrackingAccordingValue = styled.div<estimationType>`
  max-height: 375px;
  overflow-y: visible;
  ${(props) => {
    if (props?.array && props?.array > 4) {
      return css`
        overflow-y: scroll;
      `;
    }
  }}
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${COLORS.SpanishGray};
    border-radius: 7px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  background: ${COLORS.White};
  border: 1px solid ${COLORS.LightGray};
  border-radius: 6px;
`;

export const EstimationTrackingHeaders = styled.div`
  padding: ${rem(15)} ${rem(20)};
  background: #F4F5F7; /* Match the gray background of the headers */
  border-bottom: 1px solid ${COLORS.LightGray};
  border-radius: 6px 6px 0 0;
`;

export const EstimationTrackingValue = styled.div<{ isNew?: boolean }>`
  padding: ${rem(15)} ${rem(20)};
  background-color: white;
  border-bottom: 1px solid ${COLORS.LightGray};
  &:last-child {
    border-bottom: 0;
    border-radius: 0 0 6px 6px;
  }
`;

